import React from 'react';
import './AnimatedBackground.css';

export default function AnimatedBackground() {
    return (
        <div className="animated-background">
            <svg className="background-svg" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
                <defs>
                    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="rgba(220, 38, 38, 0.3)" />
                        <stop offset="100%" stopColor="rgba(153, 27, 27, 0.3)" />
                    </linearGradient>
                </defs>

                {/* Animated connecting lines */}
                <line x1="100" y1="150" x2="400" y2="300" stroke="url(#grad1)" strokeWidth="2" className="line-animate" />
                <line x1="400" y1="300" x2="800" y2="200" stroke="url(#grad1)" strokeWidth="2" className="line-animate" style={{ animationDelay: '0.5s' }} />
                <line x1="800" y1="200" x2="1000" y2="500" stroke="url(#grad1)" strokeWidth="2" className="line-animate" style={{ animationDelay: '1s' }} />
                <line x1="1000" y1="500" x2="600" y2="700" stroke="url(#grad1)" strokeWidth="2" className="line-animate" style={{ animationDelay: '1.5s' }} />

                {/* Floating nodes */}
                <circle cx="100" cy="150" r="8" fill="rgba(220, 38, 38, 0.6)" className="node-pulse" />
                <circle cx="400" cy="300" r="8" fill="rgba(153, 27, 27, 0.6)" className="node-pulse" style={{ animationDelay: '0.3s' }} />
                <circle cx="800" cy="200" r="8" fill="rgba(220, 38, 38, 0.6)" className="node-pulse" style={{ animationDelay: '0.6s' }} />
                <circle cx="1000" cy="500" r="8" fill="rgba(153, 27, 27, 0.6)" className="node-pulse" style={{ animationDelay: '0.9s' }} />
                <circle cx="600" cy="700" r="8" fill="rgba(220, 38, 38, 0.6)" className="node-pulse" style={{ animationDelay: '1.2s' }} />

                {/* Background floating circles */}
                <circle cx="150" cy="400" r="60" fill="rgba(220, 38, 38, 0.1)" className="float-circle" />
                <circle cx="900" cy="350" r="80" fill="rgba(153, 27, 27, 0.1)" className="float-circle" style={{ animationDelay: '-2s' }} />
                <circle cx="500" cy="100" r="70" fill="rgba(220, 38, 38, 0.1)" className="float-circle" style={{ animationDelay: '-4s' }} />
            </svg>
        </div>
    );
}
